import { AxiosResponse } from 'axios'
import { IEntityGST } from 'services/core/genericEntityGST'
import { RequestGST } from 'services/Instances'

export const DashboardServices = () => {
  const getDashboard = async (body: IGetDashboardBody): Promise<AxiosResponse<IEntityGST<IGetAllDashboardResponse>>> =>
    await RequestGST.post('Dashboard/FiltrarDashboard', body)

  const getPizzaGraphicData = async (body: IGetPizzaReportBody): Promise<AxiosResponse<IEntityGST<IPizzaReportResponse>>> =>
    await RequestGST.post('Dashboard/GerarGraficoPizza', body)

  const getBarGraphicData = async (body: IGetBarReportBody): Promise<AxiosResponse<IEntityGST<IBarReportResponse[]>>> =>
    await RequestGST.post('Dashboard/GerarGraficoBarra', body)

  return {
    getDashboard,
    getPizzaGraphicData,
    getBarGraphicData,
  }
}

export interface IGetDashboardBody {
  periodoInicio: string;
  periodoFim: string;
  matriculaContraparte: string;
  nomeContraparte: string;
  matriculaContraparteSubstituto: string;
  nomeContraparteSubstituto: string;
  nomeEmpresa: string;
  nomeCentro: string;
  nomeFornecedor: string;
  idUnidadeGestora: number;
  idContrapartes: number[];
  idContraparteSubstitutos: number[];
  idEmpresas: number[];
  idFornecedors: number[];
  idCentroPlantas: number[];
}

export interface IGetBarReportBody {
  tipoDashboard: string;
  periodoInicio: string;
  periodoFim: string;
  idContrapartes: number[];
  idContraparteSubstitutos: number[];
  idEmpresas: number[];
  idCentroPlantas: number[];
  idFornecedors: number[];
  idUnidadeGestora: number;
}

export interface IBarReportResponse {
  nomeItemSeguranca: string;
  quantidadeItens: number;
}

export interface IGetPizzaReportBody {
  tipoDashboard: string;
  periodoInicio: string;
  periodoFim: string;
  idUnidadeGestora: number;
  idContrapartes: number[];
  idContraparteSubstitutos: number[];
  idEmpresas: number[];
  idCentroPlantas: number[];
  idFornecedors: number[];
}

export interface IPizzaReportResponse {
  qtDocumentosRegulares: number
  qtDocumentosIrregulares: number
  vlRiscoComIntervencao: number
  vlRiscoSemIntervencao: number
  qtFornecedorRegular: number
  qtFornecedorIrregular: number
}

export interface ListaContraparte {
  id: number;
  nomeContraparte: string;
  matriculaContraparte: string;
  idContraparteSubstituto: number;
  nomeContraparteSubstituto: string;
  matriculaContraparteSubstituto: string;
}

export interface ListaEmpresa {
  id: number;
  descricaoEmpresa: string;
}

export interface ListaCentro {
  id: number;
  descricaoCentroPlanta: string;
}

export interface ListaFornecedore {
  id: number;
  nomeFornecedor: string;
  codigoFornecedor: string;
}

export interface ListaContraparteSubstituto {
  id: number
  nomeContraparteSubstituto: string
  matriculaContraparteSubstituto: string
}

export interface IGetAllDashboardResponse {
  listaContrapartes: ListaContraparte[];
  listaEmpresas: ListaEmpresa[];
  listaCentros: ListaCentro[];
  listaFornecedores: ListaFornecedore[];
  listaContrapartesSubstituto: ListaContraparteSubstituto[];
}
